import { tns } from 'tiny-slider/src/tiny-slider.module'

function imageCarousel() {
  [].forEach.call(document.querySelectorAll('[data-carousel]'), (el) => {
    const carousel = tns({
      container: el,
      items: 1,
      nav: true,
      mouseDrag: true,
      arrowKeys: false,
      autoplay: true,
      controls: false,
      speed: 500,
      autoplayButtonOutput: false,
      gutter: 0,
    })
  })
}

export default imageCarousel
